
























































































import { mixins } from "vue-class-component";
import { Component, Prop } from "vue-property-decorator";
import Multiselect from "vue-multiselect";
import { getModule } from "vuex-module-decorators";

import FormErrors from "@/lib/components/FormErrors.vue";
import FormField from "@/lib/components/FormField.vue";
import SubmitButton from "@/lib/components/SubmitButton.vue";

import GeneralFormMixin from "@/lib/mixins/GeneralForm";
import dataStore from "@/store";
import Product from "@/modules/plushie/product.model";
import PlushieStore from "@/modules/plushie/store";

@Component({
  components: { FormErrors, FormField, Multiselect, SubmitButton },
})
export default class HolidayPeriodProductGroupForm extends mixins(
  GeneralFormMixin
) {
  @Prop({ default: false })
  public readonly editing!: boolean;

  @Prop({ default: () => [] })
  public readonly productIds!: string[];

  @Prop({ default: () => [] })
  public readonly unavailableProductIds!: string[];

  public selectedProduct: Product | null = null;
  private fPlushieStore: PlushieStore;
  private fStagedProductIds: string[] = [];

  get eligibleProducts(): Product[] {
    return this.fPlushieStore.productsList.filter(
      (product) =>
        !this.fStagedProductIds.includes(product.id) &&
        !this.unavailableProductIds.includes(product.id)
    );
  }

  get stagedProducts(): Product[] {
    return this.fStagedProductIds
      .map((id) => this.fPlushieStore.getProductById(id))
      .filter((product): product is Product => product !== undefined)
      .sort((left, right) =>
        left.name.toLowerCase().localeCompare(right.name.toLowerCase())
      );
  }

  constructor() {
    super();
    this.fPlushieStore = getModule(PlushieStore, dataStore);
  }

  public addProduct(): void {
    const product = this.selectedProduct;
    if (
      !product ||
      this.isDisabled ||
      !this.eligibleProducts.some((item) => item.id === product.id)
    ) {
      return;
    }
    this.fStagedProductIds.push(product.id);
    this.selectedProduct = null;
  }

  public deleteProduct(productId: string): void {
    if (this.isDisabled) {
      return;
    }
    this.fStagedProductIds = this.fStagedProductIds.filter(
      (id) => id !== productId
    );
  }

  public onCancelClick(): void {
    if (!this.isDisabled) {
      this.$emit("cancel");
    }
  }

  protected created(): void {
    this.fStagedProductIds = this.productIds.slice();
  }

  protected performSubmit(): Promise<void> {
    if (!this.fStagedProductIds.length) {
      this.submitErrors = [
        "A Holiday product group needs at least one product.",
      ];
      return Promise.resolve();
    }
    this.$emit("saved", this.fStagedProductIds.slice());
    return Promise.resolve();
  }
}
